import profileInfo from "@/config/profile";
import React, { useState, useEffect, useRef } from "react";

const AboutSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const { aboutSection: profile } = profileInfo;
  const isLightTheme = profileInfo?.theme === "light";

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      id="about"
      ref={sectionRef}
      className="min-h-screen flex flex-col justify-center px-8 py-20"
    >
      <div className="max-w-4xl">
        <h2
          className={`text-sm font-light tracking-widest mb-12 transition-all duration-1000 transform ${
            isLightTheme ? "text-slate-600" : "text-gray-400"
          } ${
            isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
          }`}
        >
          ABOUT ME
        </h2>

        <div className="relative">
          <h3 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
            <span
              className={`inline-block transition-all duration-1000 delay-200 transform ${
                isVisible
                  ? "translate-y-0 opacity-100"
                  : "translate-y-20 opacity-0"
              }`}
            >
              I'm {" "}
            </span>
            <span
              className={`inline-block text-blue-500 transition-all duration-1000 delay-400 transform ${
                isVisible
                  ? "translate-y-0 opacity-100 scale-100"
                  : "translate-y-20 opacity-0 scale-75"
              }`}
            > 
              {["a", "e", "i", "o", "u"].includes(profile?.position?.[0]?.toLowerCase()) ? "an" : "a"}{" "}
              {profile?.position?.split(" ").slice(0, 2).join(" ")}
            </span>
          </h3>

          <h3 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mt-4">
            <span
              className={`inline-block text-blue-500 transition-all duration-1000 delay-600 transform ${
                isVisible
                  ? "translate-y-0 opacity-100"
                  : "translate-y-20 opacity-0"
              }`}
            >
              {profile?.position?.split(" ").slice(2).join(" ")}{" "}
            </span>
            <span
              className={`inline-block transition-all duration-1000 delay-800 transform ${
                isVisible
                  ? "translate-y-0 opacity-100"
                  : "translate-y-20 opacity-0"
              }`}
            >
              dedicated to crafting
            </span>
          </h3>

          <h3
            className={`text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mt-4 transition-all duration-1000 delay-1000 transform ${
              isVisible
                ? "translate-y-0 opacity-100"
                : "translate-y-20 opacity-0"
            }`}
          >
            high-quality, meaningful
          </h3>

          <h3
            className={`text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mt-4 transition-all duration-1000 delay-1200 transform ${
              isVisible
                ? "translate-y-0 opacity-100"
                : "translate-y-20 opacity-0"
            }`}
          >
            outcomes.
          </h3>
        </div>

        {profile?.description.map((paragraph, index) => (
            <p
              className={`text-lg mt-${
                index ? "6" : "12"
              } max-w-2xl leading-relaxed transition-all duration-1000 delay-1400 transform ${
                isLightTheme ? "text-slate-600" : "text-gray-300"
              } ${
                isVisible
                  ? "translate-y-0 opacity-100"
                  : "translate-y-10 opacity-0"
              }`}
            >
              {paragraph}
            </p>
          ))}
      </div>
    </section>
  );
};

export default AboutSection;
